import { useNavigate, useParams, useSearchParams } from "react-router";

import { NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS, type PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetNewDayTripPlanEditPageParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.PLAN.EDIT.NEW.PLAN.DAYTRIP>>();

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const duplicateItemID = searchParams.get(NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS) ?? undefined;

	if (!hotelID) {
		navigate("/");
	}

	return {
		hotelID: hotelID!,
		duplicateItemID: duplicateItemID,
	};
};
